import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		padding: "72px 16px 8px 16px",
		height: "100vh",
		overflowY: "hidden",
		[theme.breakpoints.down("sm")]: {
			padding: "68px 8px 8px 8px",
		},
	},

	contentWrapper: {
		...theme.scrollbarStyles,
		height: "100%",
		display: "flex",
		flexDirection: "column",
		overflowY: "auto",
		backgroundColor: theme.palette.type === "dark" ? "#1E293B" : "#FFFFFF",
		borderRadius: 16,
		boxShadow: theme.palette.type === "dark"
			? "0 1px 3px rgba(0,0,0,0.3)"
			: "0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.02)",
	},
}));

const MainContainer = ({ children }) => {
	const classes = useStyles();

	return (
		<Container maxWidth={false} className={classes.mainContainer}>
			<div className={classes.contentWrapper}>{children}</div>
		</Container>
	);
};

export default MainContainer;
